// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qocG4","newExpiryDate":"styles_newExpiryDate__3Yngr","footer":"styles_footer__oavxm"};